export const SITE_ORIGIN = 'https://oursexquiz.com';

export const STATIC_SITEMAP_PATHS = ['/', '/privacy', '/affiliates', '/blog'] as const;

type RouteSeoKind =
  | 'public-home'
  | 'public-privacy'
  | 'public-blog'
  | 'public-blog-category'
  | 'public-blog-post'
  | 'public-affiliates'
  | 'app-flow'
  | 'mock'
  | 'internal-tool'
  | 'other';

export interface RouteSeo {
  kind: RouteSeoKind;
  indexable: boolean;
  noindex: boolean;
  prerender: boolean;
  sitemap: boolean;
  canonicalPath: string | null;
  title?: string;
  description?: string;
}

const HOME_SEO = {
  title: "Couples Sex Quiz – Discover What You're Both Into",
  description:
    'A fun, private couples sex quiz that reveals only what you both say yes to. Discover shared desires and explore something new tonight.',
} as const;

const PRIVACY_SEO = {
  title: 'Privacy Policy | OurSexQuiz',
  description:
    'Read how OurSexQuiz handles anonymous sessions, analytics, payments, and automatic data deletion.',
} as const;

function isBlogPostPath(pathname: string): boolean {
  return /^\/blog\/[^/]+$/.test(pathname) && pathname !== '/blog';
}

function isBlogCategoryPath(pathname: string): boolean {
  return /^\/blog\/category\/[^/]+$/.test(pathname);
}

function isAppFlowPath(pathname: string): boolean {
  return (
    pathname === '/start' ||
    /^\/(share|quiz|waiting|results|unlock)\//.test(pathname)
  );
}

function isMockPath(pathname: string): boolean {
  return pathname.startsWith('/mock/');
}

export function getRouteSeo(pathname: string): RouteSeo {
  if (pathname === '/') {
    return {
      kind: 'public-home',
      indexable: true,
      noindex: false,
      prerender: true,
      sitemap: true,
      canonicalPath: '/',
      ...HOME_SEO,
    };
  }

  if (pathname === '/privacy') {
    return {
      kind: 'public-privacy',
      indexable: true,
      noindex: false,
      prerender: true,
      sitemap: true,
      canonicalPath: '/privacy',
      ...PRIVACY_SEO,
    };
  }

  if (pathname === '/affiliates') {
    return {
      kind: 'public-affiliates',
      indexable: true,
      noindex: false,
      prerender: true,
      sitemap: true,
      canonicalPath: '/affiliates',
      title: 'Affiliate Program – 50% Commission | OurSexQuiz',
      description:
        'Earn 50% commission sharing OurSexQuiz with your audience. 60-day attribution, monthly payouts. Apply now — approval within a few days.',
    };
  }

  if (pathname === '/blog') {
    return {
      kind: 'public-blog',
      indexable: true,
      noindex: false,
      prerender: true,
      sitemap: true,
      canonicalPath: '/blog',
      title: 'Blog | OurSexQuiz',
      description:
        'Tips, guides, and insights for couples. Explore our articles on relationships, intimacy, and sexual wellness.',
    };
  }

  if (isBlogCategoryPath(pathname)) {
    return {
      kind: 'public-blog-category',
      indexable: true,
      noindex: false,
      prerender: true,
      sitemap: true,
      canonicalPath: pathname,
    };
  }

  if (isBlogPostPath(pathname)) {
    return {
      kind: 'public-blog-post',
      indexable: true,
      noindex: false,
      prerender: true,
      sitemap: true,
      canonicalPath: pathname,
    };
  }

  if (isAppFlowPath(pathname)) {
    return {
      kind: 'app-flow',
      indexable: false,
      noindex: true,
      prerender: false,
      sitemap: false,
      canonicalPath: null,
    };
  }

  if (isMockPath(pathname)) {
    return {
      kind: 'mock',
      indexable: false,
      noindex: true,
      prerender: false,
      sitemap: false,
      canonicalPath: null,
    };
  }

  if (pathname === '/stats') {
    return {
      kind: 'internal-tool',
      indexable: false,
      noindex: true,
      prerender: false,
      sitemap: false,
      canonicalPath: '/stats',
    };
  }

  return {
    kind: 'other',
    indexable: false,
    noindex: true,
    prerender: false,
    sitemap: false,
    canonicalPath: null,
  };
}

export function isIndexablePath(pathname: string): boolean {
  return getRouteSeo(pathname).indexable;
}

export function isPrerenderedPublicPath(pathname: string): boolean {
  return getRouteSeo(pathname).prerender;
}

export function shouldNoindexPath(pathname: string): boolean {
  return getRouteSeo(pathname).noindex;
}

export function toAbsoluteUrl(pathname: string): string {
  return `${SITE_ORIGIN}${pathname}`;
}
